import type { SubmitEvent } from "react";

import { resolveAnalyticsElement } from "@/lib/analytics/analyticsElement";
import type { AnalyticsElementId } from "@/lib/analytics/analyticsElementId";

type FormAnalyticsOptions = {
  analyticsElementId: AnalyticsElementId;
  onSubmit: (event: SubmitEvent<HTMLFormElement>) => void | Promise<void>;
  /** Match the submit button's pending/disabled guard, including programmatic submission. */
  disabled?: boolean;
};

/**
 * Gives the form sole ownership of submission analytics, including Enter and requestSubmit().
 * Spread submitButtonProps on its submit button instead of supplying analyticsElementId there.
 * Native validation still runs first; the existing handler keeps its validation and behavior.
 */
export function resolveFormAnalytics({ analyticsElementId, onSubmit, disabled = false }: FormAnalyticsOptions) {
  const analyticsElement = resolveAnalyticsElement(analyticsElementId);
  const handleSubmit = (event: SubmitEvent<HTMLFormElement>) => {
    if (disabled) {
      event.preventDefault();
      return;
    }
    analyticsElement?.emitClick();
    return onSubmit(event);
  };

  return { onSubmit: handleSubmit, submitButtonProps: analyticsElement?.attributes };
}
